import React from "react"

export function Guide(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 0C3.13437 0 0 3.13437 0 7C0 10.8656 3.13437 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13437 10.8656 0 7 0ZM9.90391 4.44492L8.55703 7.30703C8.44688 7.54141 8.25859 7.72969 8.02422 7.83984L5.16211 9.18672C4.82539 9.34531 4.48555 9.00547 4.64414 8.66875L5.99102 5.80664C6.10117 5.57227 6.28945 5.38398 6.52383 5.27383L9.38594 3.92695C9.72266 3.76836 10.0625 4.10859 9.90391 4.44492Z"
        fill="currentColor"
      />
    </svg>
  )
}
